import type {
  AddDelayType,
  AddGamePlayerType,
  AddPlayers
} from '@library/types/boardBuilder';
import {
  BoardBuilderGameHeader,
  BoardBuilderGamePlayers
} from '@bo-components/boardBuilder';
import { useEffect, useState } from 'react';
import type { LeagueGameData } from '@library/types/games';
import { classNames } from '@library/utils';

export interface BoardBuilderGameProps {
  game: LeagueGameData;
  leagueId: string;
  onSelectPlayer: ({ game, player }: AddGamePlayerType) => void;
  onUnSelectPlayer: ({ game, player }: AddGamePlayerType) => void;
  onAddDelay: ({ gameId, delay }: AddDelayType) => void;
  searchValue: string;
  selectedDate: string;
  selectedPlayersList: AddPlayers;
  selectedPositions: Array<string>;
  selectedTeams: Array<string>;
}

export const BoardBuilderGame = ({
  game,
  leagueId,
  onSelectPlayer,
  onUnSelectPlayer,
  onAddDelay,
  searchValue,
  selectedDate,
  selectedPlayersList,
  selectedPositions,
  selectedTeams
}: BoardBuilderGameProps) => {
  const [showPlayers, setShowPlayers] = useState(false);
  const [showAllPlayers, setShowAllPlayers] = useState(false);
  const [hasSearchPlayers, setHasSearchPlayers] = useState(false);

  const hasSearchValue = !!searchValue.length;

  useEffect(() => {
    if (hasSearchValue) {
      setShowPlayers(true);
      return;
    }
    setShowPlayers(false);
    setHasSearchPlayers(false);
  }, [hasSearchValue]);

  const { teams } = game;

  const handleTogglePlayers = (displayPlayers: boolean) => {
    setShowPlayers(displayPlayers);
    if (!displayPlayers) {
      setShowAllPlayers(false);
    }
  };

  return (
    <div
      className={classNames(
        'border-soFresh-140 mb-2 inline-flex w-[375px] flex-col items-start justify-start gap-4 rounded border',
        showPlayers && hasSearchPlayers ? 'max-h-[500px]' : ''
      )}
    >
      <BoardBuilderGameHeader
        onTogglePlayers={() => handleTogglePlayers(!showPlayers)}
        onAddDelay={onAddDelay}
        game={game}
        showPlayers={showPlayers}
      />
      {showPlayers && (
        <BoardBuilderGamePlayers
          gameDate={selectedDate}
          game={game}
          leagueId={leagueId}
          onSearchPlayers={({ value }) => setHasSearchPlayers(value)}
          onSelectPlayer={onSelectPlayer}
          onShowAllPlayersClick={() => setShowAllPlayers(!showAllPlayers)}
          onUnSelectPlayer={onUnSelectPlayer}
          searchValue={searchValue}
          selectedPlayersList={selectedPlayersList}
          selectedTeams={selectedTeams}
          selectedPositions={selectedPositions}
          showAllPlayers={showAllPlayers}
          teams={teams}
        />
      )}
    </div>
  );
};
